import { useQuery } from "@tanstack/react-query";
import { getCandidate } from "app/api/candidate_api";

const useGetCandidate = (id, tab, refetchOnMount = "always", staleTime = 30 * 60 * 60, ...rest) => {
  return useQuery({
    queryKey: ["candidate", id, tab, ...rest],
    queryFn: () => getCandidate(id),
    staleTime: staleTime,
    enabled: !!id,
    refetchOnMount: refetchOnMount
  });
};

export default useGetCandidate;
